export default __webpack_public_path__ + "static/media/partener-tecnici.c39e7102.png";